import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { compose, branch, renderNothing, renderComponent, withProps, setDisplayName } from 'react-recompose';
import get from 'lodash/get';
import { authorized } from '../containers/Authorization';
import GraphQLLoader from '../components/GraphQLLoader';
import GraphQLError from '../components/GraphQLError';

const EnabledFeaturesQuery = gql`
  query enabledFeatures {
    viewer {
      id
      enabledFeatures
    }
  }
`;

const FreemiumQuery = gql`
  query freemiumQuery {
    viewer {
      id
      heAccount {
        id
        freemium
        activeSubscriptions
      }
    }
  }
`;

const withFreemiumPropQuery = compose(
  authorized(),
  setDisplayName('withFreemiumPropQuery'),
  graphql(FreemiumQuery),
  GraphQLLoader,
  GraphQLError,
  withProps(({ data: { viewer } }) => ({
    freemium: get(viewer, 'heAccount.freemium'),
    activeSubscriptions: get(viewer, 'heAccount.activeSubscriptions'),
  })),
);

const withEnabledFeatures = compose(
  authorized(),
  setDisplayName('withEnabledFeatures'),
  graphql(EnabledFeaturesQuery),
  GraphQLLoader,
  GraphQLError,
  withProps(({ data: { viewer } }) => ({
    enabledFeatures: viewer && viewer.enabledFeatures,
  })),
);

function hasFeature(features, options, enabled) {
  return compose(
    setDisplayName(enabled ? 'onFeatureEnabled': 'onFeatureDisabled'),
    withEnabledFeatures,
    branch(
      ({ enabledFeatures }) => [].concat(features).every((feature) => enabledFeatures.includes(feature) !== enabled),
      renderComponent(options.failure || renderNothing()),
    ),
  );
}

const onFeatureEnabled = (features, options) => hasFeature(features, options || {}, true);
const onFeatureDisabled = (features, options) => hasFeature(features, options || {}, false);

export {
  EnabledFeaturesQuery,
  withEnabledFeatures,
  withFreemiumPropQuery,
  onFeatureEnabled,
  onFeatureDisabled,
};
